export default __webpack_public_path__ + "static/media/unpin.54e82504.svg";